<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg' }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Remove Equipment
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div>
                <p>Are you sure you want to remove <span class="font-medium">{{ equipment?.name }}</span>?</p>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" :loading="loading" color="red">
                        Remove
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import type { FieldPostEquipment } from '~/types/fieldPost'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [void]
}>()

const props = defineProps<{
    open: boolean
    equipment?: FieldPostEquipment
}>()

const client = useSupabaseClient()
const toast = useToast()
const loading = ref(false)

async function confirm() {
    if (!props.equipment) return
    loading.value = true
    const { error } = await client.from('field_post_equipment').delete().eq('id', props.equipment.id)
    loading.value = false

    if (error) {
        toast.add({
            title: 'Could not remove equipment.',
            description: error.message,
            color: 'red',
            icon: 'i-ph-x-circle-duotone',
        })
        return
    }

    toast.add({ title: 'Equipment removed.', color: 'green', icon: 'i-ph-check-circle-duotone' })
    emit('reload')
    dismiss()
}

function dismiss() {
    emit('update:open', false)
}
</script>
